/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { routes } from "@bvi/admin-panel/api-routes";
import { apiContainer, getItemTags, getListTag, invalidateTags, provideTagsList, TagTypes, WithId } from "@bvi/admin-panel/shared/api";
import { getResponseData } from "@bvi/api-interfaces/response";
import {
  IOrderListResponse,
  IOrderResponse
} from '@bvi/api-interfaces/response/manage-base-data';
import { ICreateOrderRequest } from "@bvi/api-interfaces/request/order";

export const orderApi = apiContainer.injectEndpoints({
  endpoints: (builder) => ({
    getOrderList: builder.query<IOrderListResponse, void>({
      query: () => ({
        url: routes.order.findAll(),
        method: 'GET',
      }),
      providesTags: (result) =>
        result
          ? [
            ...getItemTags(TagTypes.ORDER, getResponseData(result)),
            getListTag(TagTypes.ORDER),
          ]
          : [getListTag(TagTypes.ORDER)],
    }),

    getByIdOrder: builder.query<IOrderResponse, number>({
      query: (id) => ({
        url: routes.order.findOne(),
        method: 'GET',
        params: { id },
      }),
      providesTags: provideTagsList(TagTypes.ORDER)
    }),

    createOrder: builder.mutation<
      IOrderResponse,
      ICreateOrderRequest
    >({
      query: (data) => ({
        url: routes.order.create(),
        method: 'POST',
        data,
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORDER)),
    }),

    updateOrder: builder.mutation<
      IOrderResponse,
      WithId<ICreateOrderRequest>
    >({
      query: ([id, data]) => ({
        url: routes.order.update(),
        method: 'PUT',
        data: { id, name: data.name },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORDER)),
    }),

    deleteOrder: builder.mutation<void, number>({
      query: (id) => ({
        url: routes.order.remove(),
        method: 'DELETE',
        params: { id },
      }),
      invalidatesTags: invalidateTags(getListTag(TagTypes.ORDER)),
    }),
  })
});

export const {
  useGetOrderListQuery,
  useGetByIdOrderQuery,
  useCreateOrderMutation,
  useUpdateOrderMutation,
  useDeleteOrderMutation,
} = orderApi;

